import React from 'react';
import { ExternalLink } from 'lucide-react';
import { serviceAreas } from '../data/site';
const EMBED_SRC = 'https://www.google.com/maps?q=Denton,+Texas&z=9&output=embed';
const DIRECT_LINK = 'https://www.google.com/maps/place/Denton,+TX';
export function ServiceAreaMap() {
  const {
    hq,
    radiusMiles
  } = serviceAreas;
  return <div className="flex flex-col gap-3" data-id="element-173" data-mp="iilktp01lray">
      <div className="h-[340px] w-full border border-white/10 bg-steel-900 lg:h-[520px]" data-id="element-174" data-mp="dk1yvolg8fil">
        <iframe title={`Google map of the Triple D Welding & Fabrication service area around ${hq.name}`} src={EMBED_SRC} className="h-full w-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-175" data-mp="dhp7ylxpqute" />
      </div>
      <a href={DIRECT_LINK} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 self-start font-mono text-[10px] uppercase tracking-[0.2em] text-steel-300 transition-colors hover:text-brand-light" data-id="element-176" data-mp="1yx4oncrpe4t8">
        <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" data-id="element-177" data-mp="21z1xyp4tzk5f" />
        Open {hq.name} · {radiusMiles}-mile radius in Google Maps
      </a>
    </div>;
}